module.exports = __webpack_public_path__ + "img/dark-logo.a6a2f689.png";